import { ITypedReduxAction } from '../../types/redux/actionType';
import { ETab } from '../../types/tab';

export enum ETabActionTypes {
  SetActiveTab = 'TAB/SET_ACTIVE_TAB',
}

export type TSetActiveTabType = ITypedReduxAction<ETabActionTypes.SetActiveTab, ETab>;

export type TTabActions = TSetActiveTabType;
